export default __webpack_public_path__ + "static/media/image_example_action.e161494f.svg";